import { Link } from "react-router-dom";
import TestItems from "./TestItems";
import { useTranslation } from "react-i18next";
import { FaClipboardList } from "react-icons/fa6";

function TestPreview() {
  const { t } = useTranslation();
  return (
    <div className="">
      <div className="flex justify-between font-bold mb-2 items-center">
        <div className="flex items-center gap-2 font-bold">
          <FaClipboardList className="text-emerald-400 w-4 h-4 shrink-0" />
          <p>{t("tests.title")}</p>
        </div>
        <Link
          to="/tests"
          className="bg-gray-800 px-3 text-sm font-semibold rounded-full flex items-center"
        >
          {t("showFull")}
        </Link>
      </div>
      <TestItems limit={3} showMore={true} />
    </div>
  );
}

export default TestPreview;
